import { render, staticRenderFns } from "./CollectionInput.vue?vue&type=template&id=07e5c414&"
import script from "./CollectionInput.vue?vue&type=script&lang=js&"
export * from "./CollectionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07e5c414')) {
      api.createRecord('07e5c414', component.options)
    } else {
      api.reload('07e5c414', component.options)
    }
    module.hot.accept("./CollectionInput.vue?vue&type=template&id=07e5c414&", function () {
      api.rerender('07e5c414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/CollectionInput.vue"
export default component.exports